import axios from "axios";
import {
  SetLocalStorage,
  UserDataDecode,
  encodeBase64,
} from "../../../general/functions/base64Function";
import {
  AUTH_USER_DATA_FAIL,
  AUTH_USER_DATA_REQUEST,
  AUTH_USER_DATA_RESET,
  AUTH_USER_DATA_SUCCESS,
} from "../constants/userAuthConstants";
import { API_SESSION_INFO, API_USER_LIST } from "../init/urlApi";
import {
  interview_info_dummy,
  interview_users_dummy,
} from "../../SessionMethodVideoModul/dummy/interview_dummy";

export const RLogin = (data) => async (dispatch) => {
  dispatch({
    type: AUTH_USER_DATA_RESET,
  });
};

export const AuthUserDataAction = (base64Data) => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_USER_DATA_REQUEST,
    });

    let objTmp = {};
    let authFrom = UserDataDecode(base64Data);
    console.log("decode", authFrom);
    objTmp.token = authFrom.token;
    objTmp.session = authFrom.session;
    objTmp.uId = authFrom.uId;

    const config = {
      headers: {
        Authorization: `Bearer ${objTmp.token}`,
        "Content-Type": "application/json",
      },
    };
    const { data: user } = await axios.get(
      API_USER_LIST(objTmp.session),
      config
    );
    console.log("Get user List", user.data);
    let userTmp = user.data?.find((x) => x.uid == objTmp.uId);
    let recordTmp = user.data?.filter((x) => x.type == "RECORDING");
    let screenShareTmp = user.data?.filter((x) => x.type == "SHARE_SCREEN");

    objTmp.user = {
      uId: userTmp.uid,
      name: userTmp.name,
      email: userTmp.email,
      type: userTmp?.type,
    };
    objTmp.feature = { recordUid: recordTmp, shareScreenUid: screenShareTmp };

    objTmp.listUser = user.data?.map((x) => {
      return {
        uId: x.uid,
        name: x.name,
        email: x.email,
        type: x.type,
      };
    });

    const { data: sessionInfo } = await axios.get(
      API_SESSION_INFO(objTmp.session),
      config
    );

    objTmp.sessionInfo = {
      projectId: sessionInfo.data.projectCode,
      mehodId: sessionInfo.data.methodId,
      methodName: sessionInfo.data.methodName,
      uiMode: sessionInfo.data.uiMode,
      startTime: sessionInfo.data.startTime,
      sessionTitle: sessionInfo.data.sessionTitle,
      isOpen: sessionInfo.data?.isOpen,
      expired: sessionInfo.data?.expired,
      openedOn: sessionInfo.data?.openedOn,
      assesseeGuideExist: sessionInfo.data?.assesseeGuideExist,
    };
    SetLocalStorage("bkdp_id", base64Data);
    dispatch({
      type: AUTH_USER_DATA_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: AUTH_USER_DATA_FAIL,
      payload: message,
    });
  }
};

export const AuthUserDataActionDUMMY = (base64Data) => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_USER_DATA_REQUEST,
    });

    let objTmp = {};
    let authFrom = UserDataDecode(base64Data);
    console.log("decode", authFrom);
    objTmp.token = authFrom.token;
    objTmp.session = authFrom.session;
    objTmp.uId = authFrom.uId;

    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${objTmp.token}`,
    //     "Content-Type": "application/json",
    //   },
    // };
    const user = interview_users_dummy;
    console.log("Get user List", user.data);
    let userTmp = user.data?.find((x) => x.uid == objTmp.uId);
    let recordTmp = user.data?.filter((x) => x.type == "RECORDING");
    let screenShareTmp = user.data?.filter((x) => x.type == "SHARE_SCREEN");

    objTmp.user = {
      uId: userTmp.uid,
      name: userTmp.name,
      email: userTmp.email,
      type: userTmp.type,
    };
    objTmp.feature = { recordUid: recordTmp, shareScreenUid: screenShareTmp };

    objTmp.listUser = user.data?.map((x) => {
      return {
        uId: x.uid,
        name: x.name,
        email: x.email,
        type: x.type,
      };
    });

    const sessionInfo = interview_info_dummy;

    objTmp.sessionInfo = {
      projectId: sessionInfo.data.projectCode,
      mehodId: sessionInfo.data.methodId,
      methodName: sessionInfo.data.methodName,
      uiMode: sessionInfo.data.uiMode,
      startTime: sessionInfo.data.startTime,
      sessionTitle: sessionInfo.data.sessionTitle,
      isOpen: sessionInfo.data.isOpen,
      expired: sessionInfo.data.expired,
      openedOn: sessionInfo.data?.openedOn,
      assesseeGuideExist: sessionInfo.data?.assesseeGuideExist,
    };
    SetLocalStorage("bkdp_id", base64Data);
    dispatch({
      type: AUTH_USER_DATA_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: AUTH_USER_DATA_FAIL,
      payload: message,
    });
  }
};

export const AuthUserDataActionOld = (base64Data) => async (dispatch) => {
  try {
    dispatch({
      type: AUTH_USER_DATA_REQUEST,
    });

    let objTmp = {};
    let authFrom = UserDataDecode(base64Data);
    console.log(authFrom);
    objTmp.token = authFrom.token;
    objTmp.session = authFrom.session;
    objTmp.uId = authFrom.uId;

    objTmp.user = {
      uId: authFrom.uId,
      name: "Testing",
      email: "Testing@test.com",
    };
    objTmp.feature = {
      recordUid: [{ uid: 999 }],
      shareScreenUid: [{ uid: 998 }],
    };

    objTmp.sessionInfo = {
      projectId: "PR-TEST",
      mehodId: "2",
      methodName: "INTERVIEW TEST",
      uiMode: "INTERVIEW_ASSESSOR",
      startTime: 1696919685,
    };

    SetLocalStorage("bkdp_id", base64Data);

    dispatch({
      type: AUTH_USER_DATA_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: AUTH_USER_DATA_FAIL,
      payload: message,
    });
  }
};
